import IntroSmall from '@/Framework/UI/Pages/Landing/Sections/IntroSmall';
import styles from './intro.scss';

const Intro = () => (
  <IntroSmall
    className={ styles.intro }
    title="Peace of mind pre-IPO research distribution without the premium price tag."
  />
);

export default Intro;
